import { ContentWidthEnum, PaddingType } from 'common/types/styleTypes'
import {
  borderCss,
  boxShadowCss,
  mobileBorderCss,
  mobileBoxShadowCss,
  mobilePaddingsCss,
  paddingsCss,
} from 'common/utils/styleUtilsNew'
import { contentWidthValues } from 'src/shared/constants/content-width-values'
import { BorderEntityInterface } from 'src/shared/schemas/border.schema'
import { css, styled } from 'styled-components'

export interface WebsiteFooterWrapperProps extends BorderEntityInterface {
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
  contentWidth?: ContentWidthEnum
  boxShadow?: string | undefined
  mobileBoxShadow?: string
}

export const WebsiteFooterWrapper = styled.footer<WebsiteFooterWrapperProps>`
  ${p =>
    p?.contentWidth &&
    css`
      max-width: ${contentWidthValues[p?.contentWidth]};
      margin: 0 auto;
      `};
    ${paddingsCss}
    ${borderCss}
    ${boxShadowCss}


  ${p => p.theme.phone} {
    
    ${mobilePaddingsCss}
    ${mobileBorderCss}
    ${mobileBoxShadowCss}
  }



  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobilePaddingsCss}
      ${mobileBorderCss}
      ${mobileBoxShadowCss}
    `}

`
